<template>
  <div class="xunLDeatilPage">
    <div class="header">
      <dl class="dlBox">
        <dt>
          <van-image
            :src="
              baseData.avatar ? baseData.avatar : baseUrl + 'userDefault.png'
            "
          />
        </dt>
        <dd class="ddMain">
          <span
            ><em>{{ baseData.realName }}</em>
            <van-tag type="warning">{{ baseData.position }}</van-tag>
          </span>
          <span class="lastSpan">{{ baseData.org }}</span>
        </dd>
      </dl>
    </div>
    <p class="fgx"></p>
    <div class="xunLMain">
      <p class="clearfix">
        护林方式：<span class="fr frValue">{{
          getTypeName(baseData.type)
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'hld'">
        护林工作：<span class="fr frValue">{{
          baseData.lzProtectForestNoteResult.problemRemarks
            ? baseData.lzProtectForestNoteResult.problemRemarks
            : ""
        }}</span>
      </p>
      <p class="clearfix" v-else>
        护林工作：<span class="fr frValue">{{
          baseData.protectForestListResult &&
          baseData.protectForestListResult.patrolTypeName
            ? baseData.protectForestListResult.patrolTypeName
            : ""
        }}</span>
      </p>
      <p
        class="clearfix"
        v-if="baseData.type == 'hld' || baseData.type == 'qd'"
      >
        护林时间：<span class="fr frValue">{{
          baseData.type == "hld"
            ? baseData.lzProtectForestNoteResult.patrolTime
            : baseData.protectForestListResult.createTime
            ? baseData.protectForestListResult.createTime
            : baseData.protectForestListResult.startTime
        }}</span>
      </p>
      <p
        class="clearfix"
        v-if="baseData.type == 'xl' || baseData.type == 'xlz'"
      >
        开始时间：<span class="fr frValue">{{
          baseData.protectForestListResult.startTime
        }}</span>
      </p>
      <p
        class="clearfix"
        v-if="baseData.type == 'xl' || baseData.type == 'xlz'"
      >
        结束时间：<span class="fr frValue">{{
          baseData.protectForestListResult.endTime
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'xl'">
        巡林时长：<span class="fr frValue">{{
          getXunLTime(
            baseData.protectForestListResult.startTime,
            baseData.protectForestListResult.endTime
          )
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'xl'">
        巡护里程(米)：<span class="fr frValue">{{
          baseData.protectForestListResult.distance
            ? Number(baseData.protectForestListResult.distance).toFixed(2)
            : ""
        }}</span>
      </p>

      <p class="clearfix" v-if="baseData.type == 'qd'">
        签到说明：<span class="fr frValue">{{
          baseData.protectForestListResult.remarks
            ? baseData.protectForestListResult.remarks
            : ""
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'hld'">
        发现问题情况：<span class="fr frValue">{{
          baseData.lzProtectForestNoteResult.problemRemarks
            ? baseData.lzProtectForestNoteResult.problemRemarks
            : ""
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'hld'">
        是否交办，办理情况：<span class="fr frValue">{{
          baseData.lzProtectForestNoteResult.workRemarks
            ? baseData.lzProtectForestNoteResult.workRemarks
            : ""
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'hld'">
        参与人员：<span class="fr frValue">{{
          baseData.lzProtectForestNoteResult.userNames
            ? baseData.lzProtectForestNoteResult.userNames
            : ""
        }}</span>
      </p>
      <p class="clearfix" v-if="baseData.type == 'hld'">
        记录人员：<span class="fr frValue">{{
          baseData.lzProtectForestNoteResult.creatorName
            ? baseData.lzProtectForestNoteResult.creatorName
            : ""
        }}</span>
      </p>
    </div>
    <p
      class="fgx"
      v-if="
        (baseData.lzProtectForestNoteResult &&
          baseData.lzProtectForestNoteResult.locationPoint) ||
        commonType == 'qd' ||
        commonType == 'xl'
      "
    ></p>
    <div
      class="xunLMapBox"
      v-if="
        (baseData.lzProtectForestNoteResult &&
          baseData.lzProtectForestNoteResult.locationPoint) ||
        commonType == 'qd' ||
        commonType == 'xl'
      "
    >
      <p>巡护位置</p>
      <div class="xunLMap" v-if="commonType == 'qd' || commonType == 'xl'">
        <map-locator :param="params" mode="h5"></map-locator>
      </div>
      <div class="xunLMap" v-else>
        <hld-locator
          mode="h5"
          :paramPoint="paramPoint"
          v-if="
            baseData.lzProtectForestNoteResult &&
            baseData.lzProtectForestNoteResult.locationPoint
          "
        ></hld-locator>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import mapLocator from "@/components/map/MapLocator";
import hldLocator from "@/views/xunlin/components/hldLocator";
export default {
  name: "xunLDetail",
  components: { mapLocator, hldLocator },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      baseData: {},
      commonId: "",
      commonType: "",
      uid: "",
      params: {},
      paramPoint: {}, //护林单的点
      clientType: getDeviceType(),
    };
  },
  mounted() {
    document.title = "巡林记录";
    this.commonId = this.$route.query.commonId;
    this.commonType = this.$route.query.commonType;
    this.uid = this.$route.query.uid;
    this.getXunLDetail();
  },
  methods: {
    getXunLDetail() {
      let _this = this;
      _this.$api.xunLData
        .getXunLDetails(_this.commonId, {
          type: _this.commonType,
          uid: _this.uid,
        })
        .then((res) => {
          if (res.code == "1" && res.data) {
            _this.baseData = Object.assign({}, _this.baseData, res.data);

            _this.$nextTick(() => {
              if (_this.baseData.protectForestListResult.objid) {
                _this.params = {
                  type: "lz_protect_forest",
                  objid: _this.baseData.protectForestListResult.objid,
                };
              }
              if (_this.baseData.type == "hld") {
                _this.paramPoint = {
                  x: _this.baseData.lzProtectForestNoteResult.locationPoint.x,
                  y: _this.baseData.lzProtectForestNoteResult.locationPoint.y,
                };
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTypeName(type) {
      let typeName = "";
      if (type == "hld") {
        typeName = "护林单";
      } else if (type == "qd") {
        typeName = "签到";
      } else if (type == "xl") {
        typeName = "巡林";
      } else if (type == "xlz") {
        typeName = "巡林中";
      } else {
        typeName = "";
      }
      return typeName;
    },
    getXunLTime(timeStart, timeEnd) {
      let timeLeng = "", //时长
        dateDiff = "",
        hours = "",
        minutes = "";
      if (timeStart && timeEnd) {
        if (this.clientType == "android") {
          timeStart = new Date(timeStart).getTime();
          timeEnd = new Date(timeEnd).getTime();
        } else {
          timeStart = new Date(timeStart.replace(/-/g, "/")).getTime();
          timeEnd = new Date(timeEnd.replace(/-/g, "/")).getTime();
        }
        dateDiff = Number(timeEnd) - Number(timeStart);
        hours = parseInt((dateDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        minutes = parseInt((dateDiff % (1000 * 60 * 60)) / (1000 * 60));
        timeLeng =
          hours > 0 ? hours + "小时" : "" + minutes > 0 ? minutes + "分钟" : "";
      } else {
        timeLeng = "";
      }

      return timeLeng;
    },
  },
};
</script>
<style lang="less">
.xunLDeatilPage {
  width: 100%;
  height: 100%;
  font-family: "PingFangSC-Regular", "PingFang SC";
  .fgx {
    width: 100%;
    height: 12px;
    background-color: #f6f6f6;
  }
  .header {
    padding: 17px 16px;
    background-color: #fff;
    .dlBox {
      dt {
        display: inline-block;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        .van-image {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }
      .ddMain {
        display: inline-block;
        width: calc(100% - 70px);
        margin-left: 16px;
        > span {
          display: block;
          font-size: 16px;
          color: #8b8b8b;
          line-height: 22px;
          position: relative;
          em {
            height: 22px;
            display: inline-block;
            font-size: 18px;
            color: #333;
            line-height: 22px;
          }
          .van-tag {
            margin-left: 8px;
            display: inline-block;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            background-color: #ffa70a;
            vertical-align: top;
          }
        }
        .lastSpan {
          margin-top: 5px;
        }
      }
    }
  }
  .xunLMain {
    width: 100%;
    background-color: #fff;
    padding: 12px 16px;
    p {
      margin: 12px 12px;
      font-size: 15px;
      color: #7d7d7d;
      line-height: 20px;
      span {
        font-size: 15px;
        color: #333;
      }
    }
  }
  .xunLMapBox {
    padding: 0 16px;
    p {
      padding: 12px 0;
      font-size: 16px;
      font-weight: 600;
      color: #333;
      line-height: 22px;
    }
    .xunLMap {
      width: 100%;
      height: 220px;
      border-radius: 9px;

      > .dhmap-wrapper {
        width: 100%;
        height: 100%;

        canvas {
          border-radius: 9px;
        }
      }
    }
  }
}
</style>